import { useCallback } from 'react';
import { User } from 'common/interfaces/api';
import {
  isPayingPlus,
  isRenewPrimeSubStatus,
  isSubbedPrimePlusBefore,
  isSubbingPrimeByCoin,
} from 'common/utils/payment';
import { isAbleToUpgradePlan } from 'common/utils/user';
import { Button } from 'components/v2/atoms/button';
import { getPlusPackage } from 'service/payment';
import useGlobalStore from 'store/global';
import useStore from 'store/timeline';

interface PrimeSubButtonPropsType {
  user: User;
}

const PrimeSubButton = ({ user }: PrimeSubButtonPropsType) => {
  const currentUser = useStore((state) => state.currentUser);
  const showPaymentDialog = useGlobalStore((state) => state.showPaymentDialog);
  const showLogin = useGlobalStore((state) => state.showLogin);

  // Check if user is able to subscribe
  const isAbleToSub = user?.is_creator && user?.is_open_for_subscription;

  // Check subscription status
  const isNotSubbingPrime =
    !user?.creator_subscription?.current_plan ||
    !user?.creator_subscription?.status;
  const renewMode = isRenewPrimeSubStatus(user);
  const plusPackage = getPlusPackage(user);
  const ableToSubPrimePlus = !!plusPackage && !isPayingPlus(user);
  const canUpGradePlan = isAbleToUpgradePlan(user);

  // Determine if button should be shown
  const showingSubButton =
    isAbleToSub &&
    (isNotSubbingPrime || renewMode || canUpGradePlan || ableToSubPrimePlus);

  // Get button text based on subscription status
  const getButtonText = () => {
    if (renewMode || isNotSubbingPrime) {
      return 'プライム登録';
    }
    if (ableToSubPrimePlus) {
      const isSubbedPlusBefore = isSubbedPrimePlusBefore(user);
      const isSubbingByCoin = isSubbingPrimeByCoin(user);
      if (isSubbedPlusBefore) {
        return 'プライムPlus登録';
      }
      if (isSubbingByCoin) {
        return 'プライムPlus登録';
      }
      return 'プライムPlus登録';
    }
    if (canUpGradePlan) {
      return '割引プランを変更';
    }
    return 'プライム登録';
  };

  const handlePaymentClick = useCallback(() => {
    if (currentUser) {
      showPaymentDialog({
        creator: user,
      });
    } else {
      showLogin({});
    }
  }, [currentUser, user, showPaymentDialog, showLogin]);

  // Don't render if subscription button shouldn't be shown
  if (!showingSubButton) {
    return null;
  }

  return (
    <Button
      variant="primaryGreen"
      size="md"
      className="min-w-[120px] rounded-full border border-solid border-pp-green-primary font-bold"
      onClick={handlePaymentClick}
      disabled={!isAbleToSub}
    >
      {getButtonText()}
    </Button>
  );
};

export default PrimeSubButton;
